import axiosInstance from "../utils/axios";

/**
 * Get all tags with pagination and filters
 */
export const getTags = async (params) => {
    const response = await axiosInstance.get("/admin/tags", { params });
    return response.data;
};

/**
 * Get a single tag by ID
 */
export const getTagById = async (id) => {
    const response = await axiosInstance.get(`/admin/tags/${id}`);
    return response.data;
};

/**
 * Create a new tag
 */
export const createTag = async (tagData) => {
    // tagData can be JSON or FormData
    const response = await axiosInstance.post("/admin/tags", tagData);
    return response.data;
};

/**
 * Update an existing tag
 */
export const updateTag = async ({ id, tagData }) => {
    // For update, the API might require PUT or POST with _method=PUT
    const response = await axiosInstance.put(`/admin/tags/${id}`, tagData);
    return response.data;
};

/**
 * Delete a tag
 */
export const deleteTag = async (id) => {
    const response = await axiosInstance.delete(`/admin/tags/${id}`);
    return response.data;
};
